import React from 'react';
import { Navigate } from 'react-router';

import { authentication } from '@perpay-web/authentication/singleton';

export function withLoginRedirectPath(path: string) {
    return <T extends object>(Component: React.ComponentType<T>) => {
        const LoginRedirectPathWrapper = (props: T) => {
            const loggedIn = authentication.getIsAuthenticated();
            if (loggedIn) {
                return <Navigate to={path} />;
            }
            return <Component {...props} />;
        };
        LoginRedirectPathWrapper.displayName = 'LoginRedirectPathWrapper';
        return LoginRedirectPathWrapper;
    };
}
